import React from 'react';
import { Box, Grid, Typography, Chip } from '@mui/material';

const SubscriptionSummary = ({ subscriptionSummary }) => {
  if (!subscriptionSummary) {
    return null;
  }

  const daysUntilExpiry = subscriptionSummary.days_until_expiry ?? 0;
  const hasActiveSubscription = subscriptionSummary.has_active_subscription !== false;
  const normalizedStatus = (subscriptionSummary.status || '').toLowerCase();
  const isActiveStatus = normalizedStatus === 'active' || normalizedStatus === 'trial';
  const shouldShowExpired = daysUntilExpiry < 0 || !isActiveStatus || !hasActiveSubscription;
  const displayStatus = shouldShowExpired ? 'expired' : subscriptionSummary.status;
  const expiresToday = daysUntilExpiry === 0 && isActiveStatus && hasActiveSubscription;

  return (
    <Box sx={{ mb: 3,mt: 3, bgcolor: '#f8fafc', borderRadius: 2, p: 3, border: '1px solid #e2e8f0' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#1f1f1f', mr: 1.25 }}>
          {subscriptionSummary.plan_name} Plan
        </Typography>
        {subscriptionSummary.ai_provided_by_us === true && (
          <Chip 
            label="QDEX LLM" 
            size="small" 
            variant="outlined"
            sx={{
              height: 20,
              borderColor: '#0A65FF',
              color: '#0A65FF',
              backgroundColor: '#EEF4FF',
              '& .MuiChip-label': { px: 0.75, fontSize: '0.675rem', fontWeight: 600 }
            }}
          />
        )}
        {subscriptionSummary.ai_provided_by_us === false && (
          <Chip 
            label="BYO LLM" 
            size="small" 
            variant="outlined"
            sx={{
              height: 20,
              borderColor: '#CBD5E1',
              color: '#334155',
              backgroundColor: '#F1F5F9',
              '& .MuiChip-label': { px: 0.75, fontSize: '0.675rem', fontWeight: 600 }
            }}
          />
        )}
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1f1f1f' }}>
              {subscriptionSummary.prs_used}/{subscriptionSummary.prs_limit}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              PRs Used/Limit
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1f1f1f' }}>
              {subscriptionSummary.projects_used}/{subscriptionSummary.projects_allowed}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Projects Used/Allowed
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: daysUntilExpiry <= 7 ? '#ef4444' : '#1f1f1f' }}>
              {subscriptionSummary.days_until_expiry}
            </Typography>
            {expiresToday && (
              <Chip
                label="Expires Today"
                size="small"
                color="warning"
                sx={{
                  mt: 0.5,
                  textTransform: 'uppercase',
                  fontWeight: 600,
                }}
              />
            )}
            {!expiresToday && (
              <Typography variant="body2" color="text.secondary">
                Days Until Expiry
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ 
              fontWeight: 700, 
              textTransform: 'capitalize',
              color: shouldShowExpired ? '#ef4444' : 
                     isActiveStatus ? '#22c55e' : '#f59e0b' 
            }}>
              {displayStatus}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Status
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubscriptionSummary;
